export default __webpack_public_path__ + "static/media/SCalendario.e9712d3d.svg";